import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import LoadingSpinner from "../components/LoadingSpinner";

function SubUser({ apiUrl, setViewMode }) {
  const [loading, setLoading] = useState(false);
  const [serverData, setServerData] = useState([]);

  const fetchSubAccounts = async () => {
    const partnerCode = localStorage.getItem("partnerCode");

    setLoading(true);
    try {
      const response = await fetch(`https://esimgo.clay.in/api/Renew/GetPartnerSubAccounts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        body: JSON.stringify({
          id: 0,
          partnerCode: "",
          pageSize: 100,
          pageIndex: 1,
        }),
      });

      const data = await response.json();

      if (data.isSuccess) {
        setServerData(data.records || []);
      } else {
        toast.error("Failed to fetch records");
      }
    } catch (err) {
      toast.error("Server error fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubAccounts();
  }, []);

  return (
    <div className="overflow-x-auto">
      {loading && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <LoadingSpinner />
        </div>
      )}

      <table className="w-full rounded-lg shadow-lg bg-white">
        <thead className="sticky top-0 bg-gray-200">
          <tr className="border-b">
            <th className="text-center p-3">S.NO</th>
            <th className="text-center p-3">Username</th>
            <th className="text-center p-3">Email</th>
            <th className="text-center p-3">Number</th>
            <th className="text-center p-3">Role</th>
            <th className="text-center p-3">Status</th>
            <th className="text-center p-3">Country/Region</th>
            <th className="text-center p-3">Parent Email</th>
          </tr>
        </thead>

        <tbody>
          {serverData.length === 0 ? (
            <tr>
              <td colSpan="8" className="text-center h-40 font-bold">
                No Active Sub user account
              </td>
            </tr>
          ) : (
            serverData.map((row, index) => (
              <tr key={row.id} className="border-b hover:bg-gray-100">
                <td className="text-center p-1">{index + 1}</td>
                <td className="text-center p-1">{row.userName}</td>
                <td className="text-center p-1">{row.email}</td>
                <td className="text-center p-1">{row.phoneNumber}</td>
                <td className="text-center p-1">{row.role}</td>
                <td className="text-center p-1">{row.status}</td>
                <td className="text-center p-1">{row.country}</td>
                <td className="text-center p-1">{row.parentemail}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SubUser;